/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { PromotionType } from '../../../../data/products.model';
import { Button, Popover, OverlayTrigger } from 'react-bootstrap';
import './promoLabel.scss';

interface PromoLabelProps {
    promotion?: {
        promoCode?: string;
        shortPromoText: string;
        longPromoText: string;
        shortPromotionText: string;
        longPromotionText: string;
        promoLabel?: string;
    };
    small?: string;
    code?: string;
}

export function PromoLabel({
    promotion,
    small,
    code,
}: PromoLabelProps) {
    const {
        promoCode,
        promoLabel,
        shortPromoText,
        longPromoText,
        shortPromotionText,
        longPromotionText,
    } = promotion || { promoCode: code };

    const buttonClasses =
        'promo-label ' +
        ((!shortPromotionText || !shortPromoText) &&
        (!longPromotionText || !longPromoText)
            ? ' badge-empty '
            : '') +
        (small ? ' badge-promo--small' : '');

    const popover = (
        <Popover id="popover-promo">
            <Popover.Header as="h3">
                {shortPromotionText || shortPromoText}
            </Popover.Header>
            <Popover.Body>{longPromotionText || longPromoText}</Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger
            trigger="click"
            placement="top"
            overlay={popover}
            rootClose={true}
        >
            <Button className={buttonClasses}>{promoCode || promoLabel}</Button>
        </OverlayTrigger>
    );
}

PromoLabel.propTypes = {
    promotion: PropTypes.shape(PromotionType),
    small: PropTypes.bool,
};

PromoLabel.defaultProps = {
    small: false,
};
